// extracted by mini-css-extract-plugin
export default {"sms":"#85ffff","sftp":"#948be9","email":"#d56ab0","landing":"#63c2ff","webService":"#63c2ff","users":"#4fa89d"};